/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { StorageRequestBuilderRequestsMetadata, type StorageRequestBuilder } from './storage/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/companydocs/stats
 */
export interface StatsRequestBuilder extends BaseRequestBuilder<StatsRequestBuilder> {
    /**
     * The storage property
     */
    get storage(): StorageRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const StatsRequestBuilderUriTemplate = "{+baseurl}/api/companydocs/stats";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const StatsRequestBuilderNavigationMetadata: Record<Exclude<keyof StatsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    storage: {
        requestsMetadata: StorageRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
